import {
  resolveProductPrice,
  resolveProductStock,
  resolvePricePerStep
} from "../../utils/product.mjs";
import { extractConfigurableProductListingOptions } from "../../composables/products/utils.mjs";
import { computed } from "#imports";
export function mapProductListing(apiProduct) {
  const isNew = apiProduct.attributes?.find((attribute) => attribute?.key === "is_new")?.value === "Yes";
  const cartControl = {
    max: Number(apiProduct.cart_control.max_amount) ?? Number.MAX_VALUE,
    // maximum quantity allowed in the cart
    min: Number(apiProduct.cart_control.min_amount) ?? 0,
    // minimum quantity allowed in the cart
    step: Number(apiProduct.cart_control.increment_step) ?? 1
    // quantity step
  };
  const productsVariants = apiProduct.__typename === "ConfigurableProduct" ? apiProduct.variants?.map((variant) => ({
    ...variant?.product,
    price: variant?.product && resolveProductPrice(variant?.product) || 0,
    priceBefore: function() {
      const currentPrice2 = variant?.product && resolveProductPrice(variant?.product) || 0;
      const priceBefore2 = variant?.product?.price_range.maximum_price?.regular_price.value ?? currentPrice2;
      return currentPrice2 < priceBefore2 ? priceBefore2 : void 0;
    }()
  })) : [];
  const currentPrice = resolveProductPrice(apiProduct);
  const oldPrice = apiProduct.price_range.maximum_price?.regular_price.value ?? currentPrice;
  const pricePerStep = computed(
    () => resolvePricePerStep(currentPrice, Number(cartControl?.step))
  );
  const beforePricePerStep = computed(
    () => resolvePricePerStep(oldPrice, Number(cartControl?.step))
  );
  const price = computed(() => {
    if (["GroupedProduct", "ConfigurableProduct"].includes(apiProduct.__typename)) {
      return productsVariants?.reduce(
        (accu, option) => option.price < accu ? option.price : accu,
        Number.MAX_SAFE_INTEGER
      );
    }
    if (pricePerStep.value && pricePerStep.value !== currentPrice) {
      return pricePerStep.value;
    }
    return currentPrice;
  });
  const priceBefore = computed(() => {
    if (["GroupedProduct", "ConfigurableProduct"].includes(apiProduct.__typename)) {
      return productsVariants?.reduce(
        (accu, option) => option?.price < accu?.price ? option : accu,
        {
          price: Number.MAX_SAFE_INTEGER,
          priceBefore: 0
        }
      )?.priceBefore;
    }
    if (beforePricePerStep.value && beforePricePerStep.value !== oldPrice) {
      return pricePerStep.value;
    }
    return oldPrice;
  });
  return {
    id: apiProduct.id || "",
    name: apiProduct.name || "",
    sku: apiProduct.sku || "",
    isNew,
    // TODO: Remove this when product listing is extendable
    isBestseller: apiProduct.is_best_seller,
    stock: resolveProductStock(apiProduct) || 0,
    price: price.value || 0,
    priceBefore: priceBefore.value ?? 0,
    slug: apiProduct.url_key || "",
    thumb: {
      src: apiProduct.thumbnail?.url || "",
      alt: apiProduct.thumbnail?.label || apiProduct.name || ""
    },
    categories: apiProduct.categories,
    attributes: apiProduct.attributes,
    type: apiProduct.__typename,
    cartControl,
    options: extractConfigurableProductListingOptions(apiProduct),
    productsVariants,
    brand: apiProduct.brand
  };
}
